

const inkProfile = {
  controller: 'ProfileController',
  bindings: {
    provider: '<'
  },
  template: require('./profile.template.html')
};

angular
  .module('inkfinder')
  .component('inkProfile', inkProfile);



// WEBPACK FOOTER //
// ./components/profile/profile.component.js